import _ from "lodash";
import { stringToDateBeginningOfDay } from "./Date";

export const isValidDate = (dateString) => {
  // Regular expression to match the "YYYY-MM-DD" format
  const datePattern = /^\d{4}-\d{2}-\d{2}$/;

  // Check if the string matches the pattern
  if (!datePattern.test(dateString)) {
    return false;
  }

  // Attempt to create a Date object from the string
  //set to beginning of data otherrwise is uses UTC
  const date = stringToDateBeginningOfDay(dateString);

  // Check if the Date object is valid and the parsed date components match the input
  let isValid = date.getFullYear() == parseInt(dateString.substr(0, 4)) ;
    isValid = isValid && date.getMonth() + 1 == parseInt(dateString.substr(5, 2));
    isValid = isValid && date.getDate() == parseInt(dateString.substr(8, 2));

    return isValid

}

export const isDateGreaterThanToday = (dateString) => {
  const currentDate = new Date(); // Get current date in local time zone
  const [year, month, day] = dateString.split("-");
  const inputDate = new Date(year, month - 1, day); // Month is zero-based

  // Set hours, minutes, seconds, and milliseconds to zero for both dates
  currentDate.setHours(0, 0, 0, 0);
  inputDate.setHours(0, 0, 0, 0);

  return inputDate > currentDate;
}

export const isDateGreaterThanOrEqualToToday = (dateString) => {
  const currentDate = new Date(); // Get current date in local time zone
  const [year, month, day] = dateString.split("-");
  const inputDate = new Date(year, month - 1, day); // Month is zero-based

  // Set hours, minutes, seconds, and milliseconds to zero for both dates
  currentDate.setHours(0, 0, 0, 0);
  inputDate.setHours(0, 0, 0, 0);

  return inputDate >= currentDate;
}

export const isFirstDateLesserThanSecondDate = (dateString1, dateString2) => {
  
  const [year1, month1, day1] = dateString1.split("-");
  const firstDate = new Date(year1, month1 - 1, day1); // Month is zero-based

  const [year2, month2, day2] = dateString2.split("-");
  const secondDate = new Date(year2, month2 - 1, day2); // Month is zero-based

  // Set hours, minutes, seconds, and milliseconds to zero for both dates
  firstDate.setHours(0, 0, 0, 0);
  secondDate.setHours(0, 0, 0, 0);

  return firstDate < secondDate;
}

export const isDateGreaterThanMonth = (dateString) => {
  const currentDate = new Date();
  const [year, month, day] = dateString.split("-");
  const inputDate = new Date(year, month - 1, day); // Month is zero-based

  const oneMonthForward = new Date();
  oneMonthForward.setMonth(currentDate.getMonth() + 1);

  return inputDate > oneMonthForward;
}

export const isDateGreaterThanYear = (dateString) => {
  const currentDate = new Date();
  const [year, month, day] = dateString.split("-");
  const inputDate = new Date(year, month - 1, day); // Month is zero-based

  const oneYearForward = new Date();
  oneYearForward.setFullYear(currentDate.getFullYear() + 1);

  return inputDate > oneYearForward;
}


export const isDateGreaterThanMonthMinusTwoDays = (dateString) => {
  const currentDate = new Date();
  const [year, month, day] = dateString.split("-");
  const inputDate = new Date(year, month - 1, day); // Month is zero-based
  const oneMonthForward = new Date();
  oneMonthForward.setMonth(currentDate.getMonth() + 1);
  oneMonthForward.setDate(oneMonthForward.getDate() - 2);
  return inputDate > oneMonthForward;
}

export const isDateGreaterThanYearMinusTwoDays = (dateString) => {
  const currentDate = new Date();
  const [year, month, day] = dateString.split("-");
  const inputDate = new Date(year, month - 1, day); // Month is zero-based
  const oneYearForward = new Date();
  oneYearForward.setFullYear(currentDate.getFullYear() + 1);
  oneYearForward.setDate(oneYearForward.getDate() - 2);
  return inputDate > oneYearForward;
}

export const isNotXssChars = (input) => {
  const pattern = /^[^<>"'&]*$/;
  return pattern.test(input);
}

export const containsAlphabetsOnly = (str) => {
  return /^[\p{Letter}\p{Mark}]+$/gu.test(str);
}

export const containsAlphaNumOnly = (str) => {
  return /^[\p{Number}\p{Letter}\p{Mark}\s]+$/gu.test(str);
}
export const containsAlphaNumAndSpaceOnly = (str) => {
  return /^[\p{Number}\p{Letter}\p{Mark}\s]+$/gu.test(str);
}

export const containsAlphaNumAndSpaceAndPunctuationOnly = (str) => {
  return /^[\p{Letter}\p{Number}\p{Mark}\p{Punctuation}\p{Separator}\n\r\$]+$/gu.test(str);
}

export const validAddress = (str) => {
  return /^[\p{Number}\p{Letter}\p{Mark}\s\.\-'#@%&]+$/gu.test(str);
}

export const isValidUserName = (str) => {
  return /^[\p{Letter}\p{Mark}\p{Number}\$\*\?\^\-\.\+\{\}\|\/@!#%&'=_~]+$/gu.test(str);
}

export const doesStringHaveSpecialChars = (str) => {
  let specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
  return specialChars.test(str);
}

export const isNumeric = (str) => {
  if (typeof str !== "string" && typeof str !== "number") return false
  return !isNaN(str) && !isNaN(parseFloat(str)) && parseFloat(str) >= 0;
}
export const isPhoneValid = (input) => {
  //let re = /^(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
  let re = /^(\d{10})$/;
  return re.test(input);
}
export const isPostalCodeValid = (input, country) => {
  if (!country) {
    return /^[\p{Number}\p{Letter}\p{Mark}\s\-]+$/gu.test(input);
  } else if ( country === 'CA'){
    return /^[A-Za-z]\d[A-Za-z]\d[A-Za-z]\d$/gu.test(input);
  } else if ( country === 'US'){
    return /^\d{5}(?:-\d{4})?$/gu.test(input);
  }
}

export const isEmailAddressValid = (input) => {
  return String(input)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
}

export const isPasswordStrong = (input) => {
  let strongPassword = new RegExp('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})')
  return strongPassword.test(input);
}

export const isValidUUID = (input) => {
  let uuidRegExp = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i
  return uuidRegExp.test(input)
}


export const isFullFormValid = (reactState, fieldName, fieldValue, idx) => {
  let isFullFormValid = true;
  for (const [key, value] of Object.entries(reactState)) {
    if (Array.isArray(value)) {
      for (let i = 0; i < value.length; i++) {
        for (const [key1, value1] of Object.entries(value[i])) {
          if (!_.endsWith(key1, "Error")) {
            continue;
          }
          if (idx && idx === i && fieldName && key1 === fieldName) {
            isFullFormValid = isFullFormValid && !fieldValue
          } else {
            isFullFormValid = isFullFormValid && !value1
          }
        }
      }
    }

    if (!_.endsWith(key, "Error")) {
      continue;
    }
    if (fieldName && key === fieldName) {
      isFullFormValid = isFullFormValid && !fieldValue
    } else {
      isFullFormValid = isFullFormValid && !value
    }

  }
  return isFullFormValid;
}

export const kickOffFullFormValidation = (event, validityDispatcher, validator, ignoredFields) => {

  let isFormValid = true;
  let formDataIsIsolated = event.formDataIsIsolated;

  //dispatch and validate for input elements
  for (let i = 0; i < (formDataIsIsolated ? Object.entries(event.formData).length : event.target.getElementsByTagName('input').length); i++) {

    let fieldName = formDataIsIsolated ? Object.entries(event.formData)[i][0] : event.target.getElementsByTagName('input')[i].name;
    if (!_.isEmpty(ignoredFields) && _.includes(ignoredFields, fieldName)) {
      continue;
    }
    let fieldValue = formDataIsIsolated ? Object.entries(event.formData)[i][1] : event.target.getElementsByTagName('input')[i].value;
    fieldValue = fieldValue||"";//this accounts for null field values from the formdata object
    let dispatchType = 'VALIDATE_' + fieldName.toUpperCase();
    validityDispatcher({ type: dispatchType, payload: { [fieldName]: fieldValue, formData: event.formData } })
  }

  //validate whole form before moving forward
  for (let i = 0; i < (formDataIsIsolated ? Object.entries(event.formData).length : event.target.getElementsByTagName('input').length); i++) {
    let fieldName = formDataIsIsolated ? Object.entries(event.formData)[i][0] : event.target.getElementsByTagName('input')[i].name;
    if (!_.isEmpty(ignoredFields) && _.includes(ignoredFields, fieldName)) {
      continue;
    }
    let fieldValue = formDataIsIsolated ? Object.entries(event.formData)[i][1] : event.target.getElementsByTagName('input')[i].value;
    fieldValue = fieldValue||"";//this accounts for null field values from the formdata object
    let { hasError, error } = validator(fieldName, fieldValue, event.formData);
    if (hasError) {
      isFormValid = false;
      break;
    }
  }
  if (!formDataIsIsolated) {
    //dispatch and validate for textareas
    for (let i = 0; i < event.target.getElementsByTagName('textarea').length; i++) {
      let fieldName = event.target.getElementsByTagName('textarea')[i].name;
      if (!_.isEmpty(ignoredFields) && _.includes(ignoredFields, fieldName)) {
        continue;
      }
      let fieldValue = event.target.getElementsByTagName('textarea')[i].value;
      let dispatchType = 'VALIDATE_' + fieldName.toUpperCase();
      validityDispatcher({ type: dispatchType, payload: { [fieldName]: fieldValue } })
    }

    for (let i = 0; i < event.target.getElementsByTagName('textarea').length; i++) {
      let fieldName = event.target.getElementsByTagName('textarea')[i].name;
      if (!_.isEmpty(ignoredFields) && _.includes(ignoredFields, fieldName)) {
        continue;
      }
      let fieldValue = event.target.getElementsByTagName('textarea')[i].value;
      let { hasError, error } = validator(fieldName, fieldValue);
      if (hasError) {
        isFormValid = false;
        break;
      }
    }


    //selects
    for (let i = 0; i < event.target.getElementsByTagName('select').length; i++) {
      let fieldName = event.target.getElementsByTagName('select')[i].name;
      if (!_.isEmpty(ignoredFields) && _.includes(ignoredFields, fieldName)) {
        continue;
      }
      let fieldValue = event.target.getElementsByTagName('select')[i].value;
      let dispatchType = 'VALIDATE_' + fieldName.toUpperCase();
      validityDispatcher({ type: dispatchType, payload: { [fieldName]: fieldValue } })
    }

    for (let i = 0; i < event.target.getElementsByTagName('select').length; i++) {
      let fieldName = event.target.getElementsByTagName('select')[i].name;
      if (!_.isEmpty(ignoredFields) && _.includes(ignoredFields, fieldName)) {
        continue;
      }
      let fieldValue = event.target.getElementsByTagName('select')[i].value;
      let { hasError, error } = validator(fieldName, fieldValue);
      if (hasError) {
        isFormValid = false;
        break;
      }
    }

  }
  return isFormValid;
}